/* born native — 360° spin on the product page (2026-10-22), v2 2026-10-25.
   Frames live in Shopify Files (product metafields born_native.spin360 and, optionally, born_native.spin360_jacket:
   base, count, ext); the CDN returns WebP at the width the slot needs. Coarse frames load first (every 16th, then 8th,
   4th, 2nd, all), so the spin works early and gets smoother while it loads; if the slot grows (rotation, wider window)
   sharper frames replace them. Drag, arrow keys or the on-screen arrows turn it. One slow turn plays once every frame
   is in and the spin is on screen, unless the visitor prefers reduced motion or has already touched it.
   The second set (jacket without the model) is loaded only when the visitor picks it. */
(function () {
  'use strict';
  var WIDTHS = [640, 800, 960, 1200, 1440, 1920];
  var VIEWS = [[0, 'Front'], [90, 'Left side'], [180, 'Back'], [270, 'Right side']];
  var STORE = 'bn-spin-set';

  function init(wrap) {
    if (wrap.__bnSpin) return;
    wrap.__bnSpin = true;
    var el = wrap.querySelector('.bn-spin');
    if (!el) return;
    var cv = el.querySelector('.bn-spin__canvas');
    var ctx = cv.getContext('2d');
    var bar = el.querySelector('.bn-spin__bar i');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var stride = navigator.connection && navigator.connection.saveData ? 3 : 1;

    function mkSet(base, n, ext) {
      var order = [], seen = {};
      [16, 8, 4, 2, 1].forEach(function (s) {
        for (var i = 0; i < n; i += s) if (!seen[i] && i % stride === 0) { seen[i] = 1; order.push(i); }
      });
      return { base: base, n: n, ext: ext || '.jpg', order: order, imgs: new Array(n), width: 0, gen: 0, allIn: false,
               begun: false, introDone: false, used: false, pos: 0 };
    }
    var sets = {};
    var mBase = el.getAttribute('data-spin-base'), mN = parseInt(el.getAttribute('data-spin-count'), 10) || 0;
    if (!mBase || mN < 2) return;
    sets.model = mkSet(mBase, mN, el.getAttribute('data-spin-ext'));
    var aBase = el.getAttribute('data-alt-base'), aN = parseInt(el.getAttribute('data-alt-count'), 10) || 0;
    if (aBase && aN > 1) sets.alt = mkSet(aBase, aN, el.getAttribute('data-alt-ext'));

    var key = 'model', S = sets.model;
    var shown = null, dragging = false, lastX = 0, lastT = 0, vel = 0, raf = 0, intro = false, tween = 0;

    function wrapN(k) { return ((k % S.n) + S.n) % S.n; }
    function pad(i) { return ('00' + i).slice(-3); }
    function nearest(k) {
      if (S.imgs[k]) return k;
      for (var d = 1; d < S.n; d++) {
        if (S.imgs[wrapN(k + d)]) return wrapN(k + d);
        if (S.imgs[wrapN(k - d)]) return wrapN(k - d);
      }
      return -1;
    }
    function draw() {
      var j = nearest(wrapN(Math.round(S.pos)));
      if (j < 0 || S.imgs[j] === shown) return;
      var im = S.imgs[j];
      if (cv.width !== im.naturalWidth || cv.height !== im.naturalHeight) { cv.width = im.naturalWidth; cv.height = im.naturalHeight; }
      ctx.drawImage(im, 0, 0, cv.width, cv.height);
      shown = im;
      el.classList.add('is-live');
      var deg = Math.round(wrapN(Math.round(S.pos)) * 360 / S.n) % 360, text = deg + '°';
      VIEWS.forEach(function (v) { if (Math.abs(((deg - v[0] + 540) % 360) - 180) < 8) text = v[1]; });
      el.setAttribute('aria-valuenow', deg);
      el.setAttribute('aria-valuetext', text);
    }

    function targetWidth() {
      var need = el.clientWidth * Math.min(window.devicePixelRatio || 1, 2);
      for (var i = 0; i < WIDTHS.length; i++) if (WIDTHS[i] >= need) return WIDTHS[i];
      return WIDTHS[WIDTHS.length - 1];
    }
    function loadAll(set) {
      var w = targetWidth(), g = ++set.gen, first = !set.width;
      set.width = w;
      var next = 0, inflight = 0, done = 0, total = set.order.length;
      function pump() { while (inflight < 6 && next < total) start(set.order[next++]); }
      function start(i) {
        var im = new Image();
        inflight++;
        im.onload = function () {
          // decode() can hang in a hidden or throttled tab, so a timer backs it up: the queue must never stall
          var fin1 = false, ok = function () { if (fin1) return; fin1 = true; if (g === set.gen || !set.imgs[i]) set.imgs[i] = im; fin(); };
          if (im.decode) { im.decode().then(ok, ok); setTimeout(ok, 600); } else ok();
        };
        im.onerror = fin;
        im.src = set.base + pad(i) + set.ext + '?width=' + w;
      }
      function fin() {
        inflight--; done++;
        if (set === S) {
          if (first && bar) bar.style.width = (100 * done / total).toFixed(1) + '%';
          draw();
        }
        if (done === total && first) {
          set.allIn = true;
          if (set === S) { el.classList.add('is-loaded'); maybeIntro(); }
        }
        if (g === set.gen) pump();
      }
      pump();
    }
    var rt = 0;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { if (S.width && S.allIn && targetWidth() > S.width) loadAll(S); }, 400);
    });

    function visible() {
      var r = el.getBoundingClientRect(), h = window.innerHeight || document.documentElement.clientHeight;
      return r.top < h * 0.75 && r.bottom > h * 0.25;
    }
    function maybeIntro() {
      if (!S.allIn || S.introDone || S.used || reduce || !visible()) return;
      S.introDone = true; intro = true;
      var t0 = null, dur = 5600, from = S.pos, set = S;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function step(t) {
        if (!intro || set !== S) return;
        if (t0 === null) t0 = t;
        var u = Math.min((t - t0) / dur, 1);
        var e = u < 0.5 ? 4 * u * u * u : 1 - Math.pow(-2 * u + 2, 3) / 2;
        S.pos = from + e * S.n;
        draw();
        if (u < 1) raf = requestAnimationFrame(step); else { intro = false; S.pos = from; draw(); }
      });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        maybeIntro();
        if (!wrap.classList.contains('is-nudge') && !S.used) setTimeout(function () { wrap.classList.add('is-nudge'); }, 700);
      }, { threshold: 0.5 }).observe(el);
    }

    function takeOver() {
      if (intro) { intro = false; cancelAnimationFrame(raf); }
      cancelAnimationFrame(tween);
      if (!S.used) { S.used = true; wrap.classList.add('is-used'); }
    }
    function framesFor(dx) { return -dx / Math.max(el.clientWidth, 1) * S.n * 0.85; }

    el.addEventListener('pointerdown', function (e) {
      if (e.button > 0) return;
      begin(true);
      takeOver();
      cancelAnimationFrame(raf);
      dragging = true; vel = 0; lastX = e.clientX; lastT = performance.now();
      el.classList.add('is-drag');
      try { el.setPointerCapture(e.pointerId); } catch (_) {}
    });
    el.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var t = performance.now(), d = framesFor(e.clientX - lastX);
      S.pos += d;
      draw();
      vel = 0.75 * (d / Math.max(t - lastT, 1) * 16) + 0.25 * vel;
      lastX = e.clientX; lastT = t;
    });
    function release() {
      if (!dragging) return;
      dragging = false;
      el.classList.remove('is-drag');
      if (performance.now() - lastT > 90) vel = 0;
      vel = Math.max(-2.5, Math.min(2.5, vel));
      if (Math.abs(vel) < 0.05) return;
      var set = S;
      raf = requestAnimationFrame(function coast() {
        if (set !== S) return;
        S.pos += vel; vel *= 0.9; draw();
        if (Math.abs(vel) > 0.03 && !dragging) raf = requestAnimationFrame(coast);
      });
    }
    el.addEventListener('pointerup', release);
    el.addEventListener('pointercancel', release);
    el.addEventListener('lostpointercapture', release);
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
    el.addEventListener('keydown', function (e) {
      var k = e.key === 'ArrowLeft' ? 1 : e.key === 'ArrowRight' ? -1 : 0;
      if (e.key === 'Home') { takeOver(); S.pos = 0; draw(); e.preventDefault(); return; }
      if (!k) return;
      e.preventDefault();
      begin(true);
      takeOver();
      S.pos += k * Math.max(1, Math.round(S.n / 36));
      draw();
    });

    // on-screen arrows: a smooth quarter-of-a-sixth turn (about 15°) per click
    function turn(dir) {
      begin(true);
      takeOver();
      var from = S.pos, to = from + dir * Math.max(1, Math.round(S.n * 15 / 360)), t0 = null, set = S;
      tween = requestAnimationFrame(function step(t) {
        if (set !== S) return;
        if (t0 === null) t0 = t;
        var u = Math.min((t - t0) / 320, 1), e = 1 - Math.pow(1 - u, 3);
        S.pos = from + (to - from) * e;
        draw();
        if (u < 1) tween = requestAnimationFrame(step); else S.pos = to;
      });
    }
    Array.prototype.forEach.call(wrap.querySelectorAll('.bn-spin__arrow'), function (b) {
      b.addEventListener('click', function () { turn(parseInt(b.getAttribute('data-dir'), 10) || 1); });
    });

    // On model / Jacket switch
    var tabs = Array.prototype.slice.call(wrap.querySelectorAll('.bn-spin__tab'));
    function poster(k) {
      var p = wrap.querySelector('.bn-spin__poster[data-set="' + k + '"]');
      if (p && k === 'alt' && !p.getAttribute('src')) {
        var f = el.getAttribute('data-alt-poster');
        p.src = f + '?width=1280';
        p.srcset = [640, 960, 1280, 1600, 1920].map(function (w) { return f + '?width=' + w + ' ' + w + 'w'; }).join(', ');
        p.sizes = '(min-width: 990px) 60vw, 100vw';
      }
      return p;
    }
    function select(k, fromUser) {
      if (!sets[k] || k === key) return;
      cancelAnimationFrame(raf); cancelAnimationFrame(tween); intro = false; dragging = false; vel = 0;
      key = k; S = sets[k]; shown = null;
      S.pos = 0;
      el.classList.remove('is-live', 'is-loaded');
      if (S.allIn) el.classList.add('is-loaded');
      if (bar) bar.style.width = S.allIn ? '100%' : '0%';
      Array.prototype.forEach.call(wrap.querySelectorAll('.bn-spin__poster'), function (p) { p.hidden = p.getAttribute('data-set') !== k; });
      poster(k);
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-set') === k;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      el.setAttribute('aria-label', el.getAttribute(k === 'alt' ? 'data-label-alt' : 'data-label-model') || '');
      el.setAttribute('aria-valuenow', '0'); el.setAttribute('aria-valuetext', 'Front');
      if (fromUser) { try { sessionStorage.setItem(STORE, k); } catch (_) {} }
      begin(true);
      draw();
      if (S.allIn) maybeIntro();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t.getAttribute('data-set'), true); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var n = tabs[(i + d + tabs.length) % tabs.length];
        n.focus(); select(n.getAttribute('data-set'), true);
      });
      t.addEventListener('pointerenter', function () { if (t.getAttribute('data-set') === 'alt') poster('alt'); }, { once: true });
    });

    // frames start after the page has loaded (or 2.5 s at most), at once if the visitor reaches for the spin
    function begin(now) {
      if (S.begun) return;
      S.begun = true;
      var set = S;
      if (now === true || !('requestIdleCallback' in window)) setTimeout(function () { loadAll(set); }, 0);
      else requestIdleCallback(function () { loadAll(set); }, { timeout: 800 });
    }
    // remembered choice for this visit (picked before the first load so the unused set is never fetched)
    try { if (sessionStorage.getItem(STORE) === 'alt' && sets.alt) select('alt', false); } catch (_) {}
    function start() { begin(); }
    if (document.readyState === 'complete') start();
    else { window.addEventListener('load', start, { once: true }); setTimeout(start, 2500); }
  }

  function initAll(root) { Array.prototype.forEach.call((root || document).querySelectorAll('.bn-spin-wrap'), init); }
  initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
